const config = {
  placeholder: false, // when true (and only on the prd env), replaces the registration flow with the Placeholder page

  event: {
    title: "Bash on Vashon",
    titleWithYear: "Bash on Vashon 2026", // must match backend config
    location: 'Camp Sealth Vashon Island Washington',
    date: 'Wednesday December 30 2026 - Saturday January 2 2027',
    timezone: 'America/Los_Angeles'
  },

  calendar: {
    title: "Bash on Vashon",
    description: 'Join us for Bash on Vashon on Vashon Island! More info at bashonvashon.org',
    location: 'Camp Sealth Vashon Island Washington',
    start: '2026-12-30T18:00:00-08:00', // ISO 8601 format
    end: '2027-01-02T15:00:00-08:00' // ISO 8601 format
  },

  contacts: {
    info: 'registrar@bashonvashon.org',
    tech: 'tech@bashonvashon.org',
    housing: 'registrar@bashonvashon.org'
  },

  links: {
    info: 'bashonvashon.org',
    policies: {
      covid: 'example.com/covid',
      safety: 'docs.google.com/document/d/e/2PACX-1vRFgHyiyCqR8WpBqy3-odRmw2r4lxncyJjelwKz7WORj8BaVS1ortj6687remTzaQjppJ0VeL2RyjbY/pub'
    }
  },

  navbar: {
    title: "NW New Year's Camp", // navbar title text, same as the companion static site's (static-site-kit `title` prop); '' to show only the brand logo
    shortTitle: 'NWNYC', // abbreviated title shown only at medium widths (768-1023px), where it competes with the links for space; '' to always show the full title
    brand: '', // logo image path shown before the title (e.g. '/logo.png'); '' for no logo
    brandWidth: 40, // logo width & height in px, same as the companion static site's brand image `width` & `height` props; scales down proportionally if the screen is too narrow
    brandHeight: 40,
    centerLinksOnPage: false, // true centers links on the full navbar width (aligned with centered page content) rather than between the title and controls; can overlap the title if links are long
    tinted: true, // tint the navbar background with the accent color; false to use the page background
    // Navbar links, copied as-is from the companion static site's `links` (e.g. { label: 'About', href: '/about' }).
    // Root-relative hrefs point to pages on the static site (at links.info); full URLs are used unchanged.
    // Add `current: true` to the link to highlight (e.g. the static site's Registration link).
    // Leave empty for a standalone deployment with no companion site.
    links: [
      { label: 'Home', href: '/' },
      { label: 'Camp', href: '/camp' },
      { label: 'Packing', href: '/packing' },
      { label: 'Directions', href: '/directions' },
      { label: 'Photos', href: '/photos' },
      { label: 'Registration', href: '/registration', current: true },
      { label: 'Contact', href: '/contact' },
    ] as { label: string; href: string; current?: boolean }[],
  },

  nametags: {
    includePronouns: false,
    includeLastName: true
  },

  registration: {
    waitlistMode: false,
    showPreregistration: false,
    showWaiver: false,
    admissionQuantityMax: 4,
    fields: { // Order of form fields
      contact: ['first', 'last', 'nametag', 'email', 'emailConfirmation', 'phone', 'address', 'apartment', 'city', 'state', 'zip', 'country'],
      misc: ['age', 'share', 'allergies', 'carpool', 'volunteer', 'housing', 'housingNotes', 'roommate', 'agreement', 'comments']
    }
  },

  admissions: {
    mode: 'tiered', // sliding-scale|fixed|tiered
    slidingScale: {
      costRange: [120, 500],
      costDefault: 350
    },
    fixed: {
      cost: 200
    },
    tiered: {
      earlybirdCutoff: '2026-11-09', // last day to get early pricing
    }
  },

  payments: {
    processor: 'paypal', // stripe|paypal - also must set in backend config
    paymentDueDate: 'Example Payment Due Date',
    directPaymentUrl: 'www.paypal.com/ncp/payment/LS8227GFN3Z2L', // electronic payment option to pay remaining balance after selecting deposit or check payment
    coverFeesCheckbox: true,
    processorFees: {
      percent: 0.0349,
      fixed: 0.49
    },
    showPaymentSummary: true, // show summary of costs in payment section
    deposit: {
      enabled: false,
      amount: 50 // ignored if disabled
    },
    donation: {
      enabled: true,
      max: 999 // ignored if disabled
    },
    checks: {
      allowed: true, // If false, the below fields are ignored
      showPostalAddress: true, // If false, shows contact email
      payee: 'NW New Years Camp',
      address: ['NW New Years Camp', '2315 McGee Ave', 'Berkeley, CA 94703']
    }
  }
};

export default config;